import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';
import { IDaoTreasuryAssetsQueryParams, IDaoTreasuryResponseData } from 'types/interfaces';
import { treasuryAssetsProtocolTypeDescMock, treasuryAssetsProtocolTypeDetailProtocolNameDescMock, treasuryAssetsProtocolTypeProtocolNameOrgCountDescMock, treasuryAssetsProtocolTypeProtocolNameOrgCountAscMock, treasuryAssetsProtocolTypeProtocolNameTotalValueDescMock, treasuryAssetsProtocolTypeProtocolNameTotalValueAscMock, treasuryAssetsProtocolTypeDetailProtocolNameAscMock, treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdDescMock, treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdAscMock, treasuryAssetsProtocolTypeTotalValueDescMock, treasuryAssetsProtocolTypeTotalValueAscMock, treasuryAssetsProtocolTypeAscMock, topAumOrganizationsMock } from 'mockedData/daos_defi.page';

export const DaoTreasuryInvestmentsApi = {
    // getDaoTreasuryInvestments: (
    //     queryParams: IDaoTreasuryAssetsQueryParams,
    // ): Promise<AxiosResponse<IDaoTreasuryResponseData>> =>
    //     axiosInstance.get<IDaoTreasuryResponseData>('treasury-assets/total_treasuries_assets', { params: queryParams }),
    getDaoTreasuryInvestments: (
          queryParams: IDaoTreasuryAssetsQueryParams,
    ): Promise<AxiosResponse<any>> => {
      let mockData;

      if (
        queryParams.filterProtocolBy === "protocol_type" &&
        queryParams.orderBy === "organization_count" &&
        queryParams.limit === '10' && (queryParams.order === 'desc' || !queryParams.order)
      )  mockData = treasuryAssetsProtocolTypeDescMock;

      else if (
        queryParams.filterProtocolBy === "protocol_type" &&
        queryParams.orderBy === "organization_count" &&
        queryParams.limit === '10' && queryParams.order === 'asc'
      )  mockData = treasuryAssetsProtocolTypeAscMock;

      else if (
        queryParams.filterProtocolBy === "protocol_type" &&
        queryParams.orderBy === "total_value" &&
        queryParams.limit === '10' && queryParams.order === 'desc'
      )  mockData = treasuryAssetsProtocolTypeTotalValueDescMock;

      else if (
        queryParams.filterProtocolBy === "protocol_type" &&
        queryParams.orderBy === "total_value" &&
        queryParams.limit === '10' && queryParams.order === 'asc'
      )  mockData = treasuryAssetsProtocolTypeTotalValueAscMock;

      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.protocolTypeDetail === "borrow" &&
      queryParams.orderBy === "organization_count" &&
      queryParams.limit === '10' && (queryParams.order === 'desc' || !queryParams.order)) mockData = treasuryAssetsProtocolTypeDetailProtocolNameDescMock;
      

      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.protocolTypeDetail === "borrow" &&
      queryParams.orderBy === "organization_count" && queryParams.order === 'asc' &&
      queryParams.limit === '10') mockData = treasuryAssetsProtocolTypeDetailProtocolNameAscMock;
        
      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.protocolTypeDetail === "borrow" &&
      queryParams.orderBy === "total_value" && queryParams.order === 'desc' &&
      queryParams.limit === '10') mockData = treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdDescMock;
        
      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.protocolTypeDetail === "borrow" &&
      queryParams.orderBy === "total_value" && queryParams.order === 'asc' &&
      queryParams.limit === '10') mockData = treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdAscMock;

      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.orderBy === "organization_count" &&
      queryParams.limit === '10' && (queryParams.order === 'desc' || !queryParams.order)) mockData = treasuryAssetsProtocolTypeProtocolNameOrgCountDescMock;

      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.orderBy === "organization_count" &&
      queryParams.limit === '10' && queryParams.order === 'asc') mockData = treasuryAssetsProtocolTypeProtocolNameOrgCountAscMock;


      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.orderBy === "total_value" &&
      queryParams.limit === '10' && (queryParams.order === 'desc' || !queryParams.order)) mockData = treasuryAssetsProtocolTypeProtocolNameTotalValueDescMock;
      

      else if (queryParams.filterProtocolBy === "protocol_name, protocol_type" &&
      queryParams.orderBy === "total_value" && queryParams.order === 'asc' &&
      queryParams.limit === '10') mockData = treasuryAssetsProtocolTypeProtocolNameTotalValueAscMock;
      
      
      const mockResponse: AxiosResponse<any> = {
        data: mockData,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      };
    
      return Promise.resolve(mockResponse);
    },
    getDaoTreasuryTopAumOrganizations: (
        queryParams: IDaoTreasuryAssetsQueryParams,
    ): Promise<AxiosResponse<any>> => Promise.resolve({
        data: topAumOrganizationsMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
    }),
        // axiosInstance.get<IDaoTreasuryResponseData>('treasury-assets/top_aum_organizations', {
        //     params: queryParams,
        // }),
    getDaoTreasuryInvestmentsAssets: (
        queryParams: IDaoTreasuryAssetsQueryParams,
    ): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<IDaoTreasuryResponseData>('treasury-assets/organization_treasuries_assets', {
        //     params: queryParams,
        // }),
        Promise.resolve({
          data: {data: []},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
      })
};
